"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/SearchField/index.tsx
var SearchField_exports = {};
__export(SearchField_exports, {
  SearchField: () => SearchField
});
module.exports = __toCommonJS(SearchField_exports);

// src/components/SearchField/SearchField.tsx
var import_react = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));

// node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var faMagnifyingGlass = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"]
};

// src/components/SearchField/SearchField.tsx
var import_react_fontawesome = require("@fortawesome/react-fontawesome");
function SearchField(_a) {
  var _b = _a, {
    value,
    placeholder,
    onChange,
    onClick,
    className = "",
    disabledInput = false
  } = _b, otherProps = __objRest(_b, [
    "value",
    "placeholder",
    "onChange",
    "onClick",
    "className",
    "disabledInput"
  ]);
  return /* @__PURE__ */ import_react.default.createElement(
    "div",
    __spreadValues({
      className: (0, import_classnames.default)(
        "v2-flex v2-w-64 v2-h-10 v2-border v2-border-solid v2-border-neutral-300 hover:v2-border-yellow-500 focus-within:v2-border-yellow-500",
        className
      ),
      onClick
    }, otherProps),
    /* @__PURE__ */ import_react.default.createElement(
      "input",
      {
        value,
        placeholder,
        onChange: (evt) => onChange == null ? void 0 : onChange(evt.target.value),
        className: "v2-border-0 v2-py-2.5 v2-pl-5 v2-pr-4 v2-h-full v2-w-full focus:v2-outline-0",
        disabled: disabledInput
      }
    ),
    /* @__PURE__ */ import_react.default.createElement(
      import_react_fontawesome.FontAwesomeIcon,
      {
        icon: faMagnifyingGlass,
        className: "v2-box-content	v2-text-neutral-500 v2-w-5 v2-h-5 v2-py-2.5 v2-pr-3.5"
      }
    )
  );
}
